export default {
  ERROR: 'error',
  PAUSE: 'pause',
  PLAY: 'play',
  VIEW: 'view',
  AD_START: 'adStart',
  AD_COMPLETE: 'adComplete',
  LOAD_TIME: 'loadtime',
  TTFF: 'ttff',
  START: 'Start',
  FIRST_QUARTILE: 'FirstQuartile',
  SECOND_QUARTILE: 'SecondQuartile',
  THIRD_QUARTILE: 'ThirdQuartile',
  FOURTH_QUARTILE: 'FourthQuartile',
  ELAPSED: 'Elapsed',
  ELAPSED_THRESHOLD: 'ElapsedThreshold',
  THREE_SECONDS: 'ThreeSeconds',
  TEN_SECONDS: 'TenSeconds',
  THIRTY_SECONDS: 'ThirtySeconds',
  COMPLETE: 'Complete'
};
